import React from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import "../MonoPerc/MonoPerc.css";
import img1 from "../../assets/images/monop1 (2).png";
import img2 from "../../assets/images/monop2 (1).png";
import img3 from "../../assets/images/mono1.png";
import img4 from "../../assets/images/mono2.png";
import img7 from "../../assets/images/mono3.png";
import img9 from "../../assets/images/View-2.png"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaDownload } from "react-icons/fa";
import { HiArrowNarrowRight } from "react-icons/hi"
import { Link as RouterLink } from "react-router-dom";


import backgroundImage from "../../assets/images/slide2.jpeg";
import { Helmet } from "react-helmet";



const Slide = ({ src, alt }) => (
    <div>
        <img src={src} alt={alt} />
    </div>
);

const MonoPerc = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        centerPadding: "10%",
        nextArrow: (
            <div className="slick-arrow slick-next">

            </div>
        ),
        prevArrow: (
            <div className="slick-arrow slick-prev">

            </div>
        ),
    };
    const sectionStyle = {
        backgroundImage: `url(${backgroundImage})`,
        backgroundColor: '#a20000',
        backgroundBlendMode: 'multiply',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '250px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    };
    return (
        <>
            <Helmet>
                <title>Best Mono PERC Solar Modules</title>
                <meta name="description" content="Get the best Mono PERC Solar Modules from Gautam Solar for superior energy generation and long-lasting durability. Designed using advanced PERC cell technology, these modules optimise sunlight absorption, resulting in greater efficiency compared to traditional panels." />

                <meta name="keywords" content="Solar Power plant solution company, best Round Ribbon Connectors , best Mono PERC Solar Modules, solar power panels" />

                <link rel="canonical" href="https://gautamsolar.com/mono/" />

                {/* <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Product",
                        name: "Mono PERC Solar Module",
                        description:
                            "Gautam Solar's Mono PERC Solar Modules use fully automated manufacturing, Round Ribbon Connectors, and Non-Destructive Cell Cutting for high power, efficiency, reliability, and durability. Available in Bifacial and Monofacial variants, 540 Wp - 550 Wp.",
                        brand: {
                            "@type": "Brand",
                            name: "Gautam Solar",
                        },
                        manufacturer: {
                            "@type": "Organization",
                            name: "Gautam Solar",
                            url: "https://gautamsolar.com/",
                        },
                        category: "Solar Panel",
                        additionalProperty: [
                            {
                                "@type": "PropertyValue",
                                name: "Power Output",
                                value: "540 Wp - 550 Wp",
                            },
                            {
                                "@type": "PropertyValue",
                                name: "Cell Type",
                                value: "Mono PERC, Half-Cut Cells",
                            },
                            {
                                "@type": "PropertyValue",
                                name: "Ribbon Type",
                                value: "Round Ribbon Connectors (0.35mm)",
                            },
                            {
                                "@type": "PropertyValue",
                                name: "Available Variants",
                                value: "Bifacial, Monofacial",
                            },
                        ],
                    })}
                </script> */}

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Product",

                        "name": "Mono PERC Solar Modules",

                        "url": "https://gautamsolar.com/mono/",

                        "description":
                            "Gautam Solar Mono PERC Solar Modules are manufactured using advanced automated manufacturing and quality testing processes. The modules use M10 Mono PERC cells, half-cut cell technology, multi-busbar structure, Non-Destructive Cell Cutting and 0.35 mm Round Ribbon Connectors. They are available in 540 Wp to 550 Wp bifacial and monofacial configurations for utility, commercial and industrial, and rooftop solar installations.",

                        "brand": {
                            "@type": "Brand",
                            "name": "Gautam Solar"
                        },

                        "manufacturer": {
                            "@type": "Organization",
                            "name": "Gautam Solar",
                            "url": "https://gautamsolar.com/"
                        },

                        "category": "Solar Photovoltaic Module",
                        offers: {
                            "@type": "Offer",
                            availability: "https://schema.org/InStock",
                            priceCurrency: "INR",
                            price: "0",
                            priceValidUntil: "2027-12-31",
                            url: "https://gautamsolar.com/mono/",
                            seller: {
                                "@type": "Organization",
                                name: "Gautam Solar",
                            },
                        },

                        "additionalProperty": [
                            {
                                "@type": "PropertyValue",
                                "name": "Solar Cell Technology",
                                "value": "Mono PERC"
                            },
                            {
                                "@type": "PropertyValue",
                                "name": "Power Output",
                                "value": "540 Wp - 550 Wp"
                            },
                            {
                                "@type": "PropertyValue",
                                "name": "Cell Type",
                                "value": "M10 Mono PERC"
                            },
                            {
                                "@type": "PropertyValue",
                                "name": "Cell Configuration",
                                "value": "144/120 Half-Cut Cells"
                            },
                            {
                                "@type": "PropertyValue",
                                "name": "Module Variants",
                                "value": "Bifacial and Monofacial"
                            },
                            {
                                "@type": "PropertyValue",
                                "name": "Ribbon Technology",
                                "value": "0.35 mm Round Ribbon Connectors"
                            },
                            {
                                "@type": "PropertyValue",
                                "name": "Cell Cutting Technology",
                                "value": "Non-Destructive Cell Cutting (NDC)"
                            },
                            {
                                "@type": "PropertyValue",
                                "name": "Electrical Configuration",
                                "value": "Multi-Busbar Structure"
                            },
                            {
                                "@type": "PropertyValue",
                                "name": "Applications",
                                "value": "Utility, C&I and Rooftop Solar Installations"
                            },
                            {
                                "@type": "PropertyValue",
                                "name": "Performance Feature",
                                "value": "Excellent Anti-PID Performance"
                            }
                        ]
                    })}
                </script>
            </Helmet>

            <h1 className="sr-only">Mono PERC Solar Modules</h1>

            <section
                className="elementor-section elementor-top-section elementor-element elementor-element-d29e141 elementor-section-full_width elementor-section-stretched elementor-section-height-default elementor-section-height-default"
                data-id="d29e141"
                data-element_type="section"
                data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;stretch_section&quot;:&quot;section-stretched&quot;}"
                style={{ ...sectionStyle }}
            >
                <div className="elementor-background-overlay"></div>
                <Container className="elementor-container elementor-column-gap-no">
                    <Row className="elementor-row">
                        <Col className="elementor-column elementor-col-12 elementor-top-column elementor-element elementor-element-0a1c64f" data-id="0a1c64f" data-element_type="column">
                            <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                    <div
                                        className="elementor-element elementor-element-b12b60d elementor-widget elementor-widget-modina_section_title"
                                        data-id="b12b60d"
                                        data-element_type="widget"
                                        data-widget_type="modina_section_title.default"
                                    >
                                        <div className="elementor-widget-container d-flex justify-content-center">
                                            <h2 className="resText">Mono PERC Solar Modules</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Enquiry Now */}
            <Container className="py-5" lg={12} >
                <Row className="border rounded p-1">
                    <Col md={8} className="text-left" style={{ padding: "30px", fontSize: "20px", fontFamily: "serif", color: "grey", marginBlock: "auto" }}>
                        <p>
                            <span style={{ color: '#a20000' }}>Gautam Solar’s </span>Mono PERC Solar Modules utilize fully automatic setup and latest machines during the manufacturing and quality testing process to ensure solar modules with high power, efficiency, reliability, durability and strength.
                        </p>
                        <RouterLink to="/contactus" style={{ textDecoration: "none" }}>
                            <Button style={{ color: "#a20000", backgroundColor: "white" }} className="mt-3">Enquire Now <HiArrowNarrowRight /></Button>
                        </RouterLink>
                    </Col>
                    <Col md={4}>
                        <Slider {...settings}>
                            <Slide src={img2} alt="Gautam Solar Mono PERC solar module" />
                            <Slide src={img9} alt="Gautam Solar Mono PERC solar panel" />
                            <Slide src={img1} alt="Gautam Solar Mono PERC solar module" />
                        </Slider>
                    </Col>
                </Row>
            </Container>

            <section className="py-5 col-lg-12" >
                <Container>
                    <div className="box border p-3 rounded" style={{ backgroundColor: "#f5f5f5" }}>
                        <Row>
                            <Col md={6}>
                                <Image
                                    src={img3}
                                    alt="Gautam Solar Mono PERC solar module efficiency"
                                    fluid
                                    className="img-fluid hover-effect border p-1 rounded"
                                    style={{ maxWidth: "100%", margin: "0 auto", display: "block" }} // Ensure image is responsive and centered
                                />
                            </Col>
                            <Col md={6} style={{ padding: "30px", fontSize: "20px", fontFamily: "serif", color: "grey", marginBlock: "auto" }}>
                                <h2 className="text-center" style={{ color: "black" }}>Round Ribbon for Lower <span style={{ color: '#a20000' }}>Shading on Cells</span></h2>
                                <p>
                                    Featuring Round Ribbon Connectors of diameter 0.35 mm (as opposed to conventionally used flat ribbon of width 0.9 mm), Gautam Solar’s Mono PERC Solar Modules provide up to 2.5% more power due to lower shaded area on the solar cells.
                                </p>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </section>

            <section className="py-5">
                <Container>
                    <Row className="d-flex align-items-center border rounded p-2 ">
                        <Col md={6} style={{ padding: "30px", fontSize: "20px", fontFamily: "serif", color: "grey" }}>
                            <h2 className="text-center" style={{ color: "black" }}>Non-Destructive Cell Cutting for <span style={{ color: '#a20000' }}>Lower Chances of Micro-cracks</span></h2>
                            <p>
                                Gautam Solar’s Mono PERC Solar Modules incorporate Half-Cut Cells produced using Non-Destructive Cell Cutting (NDC). In this process, low-temperature laser with temperature less than 130°C is used. This helps lower the chances of micro-cracks in the solar modules.
                            </p>
                        </Col>
                        <Col md={6}>
                            <Image className="img-fluid hover-effect border p-2 rounded" src={img4} alt="N-type TOPCon Structure" fluid />
                        </Col>
                    </Row>
                </Container>
            </section>


            <section className="py-5" id="tigerneo2">
                <Container>
                    <Row className="align-items-center">
                        <Col xs={12} sm={4}>
                            <div className="fl text-right">
                                <div className="list">
                                    <ul>
                                        <li>Bigger M10 Mono PERC Solar Cells for higher wattage <i style={{ width: "40px" }}>01</i></li>
                                        <li>144/120 Half-Cut Cells for better performance in low light <i>02</i></li>
                                        <li>Multi-Busbar Structure for Lower Electrical Losses <i style={{ width: "35px" }}>03</i></li>
                                        <li>Non-Destructive Cell Cutting Process for lower chances of micro-cracks <i style={{ width: "50px" }}>04</i></li>
                                        <li>Round Ribbon Connectors for better utilization of light <i>05</i></li>
                                    </ul>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} sm={4}>
                            <div className="pic text-center">
                                <img className="img-fluid hover-effect" src={img7} alt="Gautam Solar Mono PERC solar module features" />
                            </div>
                        </Col>
                        <Col xs={12} sm={4}>
                            <div className="fr text-left">
                                <div className="list">
                                    <ul>
                                        <li><i>06</i>Versatile modules ideal for Utility/C&I/Rooftop Installations</li>
                                        <li><i style={{ width: "35px" }}>07</i>Available in Monofacial and Bifacial</li>
                                        <li><i>08</i>All Black and Silver frame available for premium aesthetics</li>
                                        <li><i style={{ width: "35px" }}>09</i>Resilient to extreme weather conditions</li>
                                        <li><i style={{ width: "35px" }}>10</i>Excellent Anti-PID Performance</li>
                                    </ul>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <Container style={{ padding: "20px" }}>
                <section>
                    <Row className="text-center">
                        <h2 style={{ color: "black", fontSize: "40px", padding: "30px" }}>Datasheet</h2>
                    </Row>
                    <Row style={{ display: "flex", padding: "20px" }}>
                        <Col className="col-lg-3 d-flex align-items-center justify-content-center" style={{ boxSizing: "border-box", border: "2px solid black", marginRight: "10px" }}>
                            <h3>Bifacial</h3>
                        </Col>
                        <Col className="col-lg-8" style={{ boxSizing: "border-box", border: "2px solid black" }}>
                            <h5 style={{ display: "flex", alignItems: "center", color: "#a20000" }}>
                                {/* <a href="/540 Wp - 550 Wp Mono-PERC Bifacial Glass-to-Backsheet (144 Cells).pdf" download style={{ textDecoration: "none", color: "#a20000" }}>
                                    <FaDownload style={{ marginRight: "10px", cursor: "pointer" }} />
                                    540 Wp - 550 Wp Mono-PERC Bifacial Glass-to-Backsheet (144 Cells)
                                </a> */}
                                <button
                                    style={{
                                        textDecoration: "none",
                                        color: "#a20000",
                                        background: "none",
                                        border: "none",
                                        padding: 0,
                                        cursor: "pointer",
                                    }}
                                    onClick={() =>
                                        window.open(
                                            "/540 Wp - 550 Wp Mono-PERC Bifacial Glass-to-Backsheet (144 Cells).pdf",
                                            "_blank"
                                        )
                                    }
                                >
                                    <FaDownload style={{ marginRight: "10px" }} />
                                    540 Wp - 550 Wp Mono-PERC Bifacial Glass-to-Backsheet (144 Cells)
                                </button>
                            </h5>
                        </Col>
                    </Row>
                    <Row style={{ display: "flex", padding: "20px" }}>
                        <Col className="col-lg-3 d-flex align-items-center justify-content-center" style={{ boxSizing: "border-box", border: "2px solid black", alignItems: "center", fontSize: "20px", marginRight: "10px" }}>
                            <h3>MonoFacial</h3>
                        </Col>
                        <Col className="col-lg-8" style={{ boxSizing: "border-box", border: "2px solid black" }}>
                            <h5 style={{ display: "flex", alignItems: "center", color: "#a20000" }}>
                                {/* <a href="/540 Wp - 550 Wp Mono-PERC Monofacial (144 Cells).pdf" download style={{ textDecoration: "none", color: "#a20000" }}>
                                    <FaDownload style={{ marginRight: "10px", cursor: "pointer" }} />
                                    540 Wp - 550 Wp Mono-PERC Monofacial (144 Cells)
                                </a> */}
                                <button
                                    style={{
                                        textDecoration: "none",
                                        color: "#a20000",
                                        background: "none",
                                        border: "none",
                                        padding: 0,
                                        cursor: "pointer",
                                    }}
                                    onClick={() =>
                                        window.open(
                                            "/540 Wp - 550 Wp Mono-PERC Monofacial (144 Cells).pdf",
                                            "_blank"
                                        )
                                    }
                                >
                                    <FaDownload style={{ marginRight: "10px" }} />
                                    540 Wp - 550 Wp Mono-PERC Monofacial (144 Cells)
                                </button>
                            </h5>
                        </Col>
                    </Row>
                </section>
            </Container>

        </>
    );
};

export default MonoPerc;
